// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-QuJ","signatureBlock":"Footer_signatureBlock__3JV9l","signature":"Footer_signature__1pFGf"};